import { AccordionDetails } from '@material-ui/core';
import styled from 'styled-components';

export const WrapperDCF = styled.div`
  width: 300px;
`;

export const Wrapper = styled.div``;

// export const AccordionDetailsNF = styled(AccordionDetails)`
export const AccordionDetailsNF = styled.div`
  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
  display: grid;
  grid-template-rows: 1fr auto;
  grid-row-gap: 1rem;
`;

export const WrapperNF = styled.div`


  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  display: grid;

  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 1rem;

  /* > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
    margin-top: 1rem;
  } */

   // Versão com exclusão de 3 filhos
  ${(props) =>
    props.version === 'version3' &&
    `
      & > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
        margin-top: ${props.applyMargin ? '1rem' : '0'};
      }
    `}

   // Versão com exclusão de 4 filhos
  ${(props) =>
    props.version === 'version4' &&
    `
      & > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
        margin-top: ${props.applyMargin ? '1rem' : '0'};
      }
    `}

  // Versão com exclusão de 5 filhos
  ${(props) =>
    props.version === 'version5' &&
    `
      & > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
        margin-top: ${props.applyMargin ? '1rem' : '0'};
      }
      // & > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)):not(:nth-child(5)) {
      //   margin-top: ${props.applyMargin ? '1rem' : '0'};
      // }
    `}

  // Versão com exclusão de 6 filhos
  ${(props) =>
    props.version === 'version6' &&
    `
      & > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)):not(:nth-child(5)):not(:nth-child(6)) {
        margin-top: ${props.applyMargin ? '1rem' : '0'};
      }
    `}

  /* > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)):not(:nth-child(5)):not(:nth-child(6)) {
    margin-top: 1rem;
  } */


  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);

    > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);

    //min-width: calc(100vw - 7.5rem);

    > div:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 425px) {
    grid-template-columns: 1fr;

    min-width: calc(100vw - 7.5rem);

    flex-direction: column;

    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  }

  /* @media (max-width: 425px) {
    display: grid;
    grid-template-columns: repeat(1, 28rem);
    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  } */


`;

export const WrapperGroupFim = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 2rem;
  }

  p {
    display: ${(props) => (props.red ? 'block' : 'none')};
    font-weight: 700;
    color: red;
  }
`;

export const WrapperFim = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.5rem;
`;

export const WrapperIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 7.5rem;
    color: ${(props) => (props.red ? 'red' : 'green')};
  }
`;

export const WrapperInputs = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }

  input {
    text-align: right;
  }
`;

export const WrapperSummary = styled.div`
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.05);

  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);

  padding: 1.5rem;
  margin-top: 1.5rem;

  display: flex;
  flex-direction: column;

  > p {
    margin-bottom: 3rem;
  }
`;

export const WrapperGroupInputs = styled.div`
  display: grid;

  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1.5rem;

  @media (max-width: 425px) {
    display: grid;
    grid-template-columns: repeat(1, 28rem);
    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  }
`;

export const WrapperGroupSample = styled.div`
  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  display: flex;
  flex-direction: row;
  grid-template-columns: repeat(4, 1fr);

  //padding: 1.5rem;
  grid-gap: 1rem;

  input {
    text-align: right;
  }

  > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
    margin-top: 1rem;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);

    align-items: baseline;

    > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 750px) {
    grid-template-columns: repeat(2, 1fr);

    flex-wrap: wrap;

    > div:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 425px) {
    grid-template-columns: 1fr;

    min-width: calc(100vw - 7.5rem);

    flex-direction: column;

    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  }
`;

export const WrapperGroupInspection = styled.div`
  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  display: flex;
  flex-direction: row;
  grid-template-columns: repeat(4, 1fr);

  //padding: 1.5rem;
  grid-gap: 1rem;

  input {
    text-align: right;
  }

  > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
    margin-top: 1rem;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);

    align-items: baseline;

    > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 750px) {
    grid-template-columns: repeat(2, 1fr);

    flex-wrap: wrap;

    > div:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 425px) {
    grid-template-columns: 1fr;

    min-width: calc(100vw - 7.5rem);

    flex-direction: column;

    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  }
`;

export const WrapperNFFoto = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(3, 30rem);
  flex-direction: column;
  grid-column-gap: 1rem;

  /* display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 1rem; */

  @media (max-width: 1024px) {
    grid-template-columns: repeat(1, 28rem);

    > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 28rem);

    > div:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 425px) {
    grid-template-columns: 1fr;

    min-width: calc(100vw - 7.5rem);

    flex-direction: column;

    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  }

  /* @media (max-width: 425px) {
    display: grid;
    grid-template-columns: repeat(1, 28rem);
    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  } */
`;

export const WrapperNFFotoimagens = styled.div`
  display: grid;

  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(1, 28rem);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 28rem);
  }

  @media (max-width: 425px) {
    display: grid;
    grid-template-columns: repeat(1, 28rem);
  }
`;
